import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const Wrapper = styled.div(() =>
  mq({
    display: 'flex',
    button: {
      width: '40px',
      height: '40px',
      '&:first-of-type': {
        marginRight: defaultTheme.spacing.xs,
      },
      '&:last-of-type': {
        marginLeft: defaultTheme.spacing.xs,
      },
    },
    div: {
      width: '65px',
      height: '40px',
    },
  }),
);
